import DetectivePokemon from './components/DetectivePokemon';
import './styles/styles.css'

function App() {

  return (
    <>
      <DetectivePokemon />
    </>
  );
}

export default App;